import { baseElementSchema } from "@/Components/Exercises/Elements/base";
import {
    stringArrayReturnOpSchema,
    stringReturnOpSchema,
} from "@/Components/Exercises/LogicOperation";
import { z } from "zod";

export const radarChartElementSchema = baseElementSchema.extend({
    type: z.literal("radarChart"),
    question: z.union([z.string(), stringReturnOpSchema]),
    fieldName: z.union([z.string(), stringReturnOpSchema]),
    isResultsPage: z.boolean().optional(),
    idsInSet: z
        .union([
            z.array(z.union([z.string(), stringReturnOpSchema])),
            stringArrayReturnOpSchema,
        ])
        .describe("Set Keys"),
});

export const radarChartElementDataSchema = z.object({
    answer: z.number().min(0).max(10),
});

export type RadarChartElement = z.infer<typeof radarChartElementSchema>;
export type RadarChartElementData = z.infer<typeof radarChartElementDataSchema>;
